import { FileTextOutlined, UnorderedListOutlined, TrophyOutlined, AppstoreAddOutlined } from "@ant-design/icons";
import { pipe, replace, toLower } from "lodash/fp";

import { Roules } from "../utils/auth";
import { Route } from "react-router-dom";
import { MainAgenda } from "../pages/activity/main-agenda";
import { MainactivityList } from "../pages/activity-list/activity-list";
import { ImportFile } from "../pages/activity-list/components/import-file";
import { ActivityListMember } from "../pages/activity-list/components/activity-list-member";
import { IndexLuckyDraw } from "../pages/lucky-draw/index";
import { PlayDraw } from "../pages/lucky-draw/components/play-draw";
import { IndexLuckyManagement } from "../pages/lucky-management/index";
import { LuckyManagementUser } from "../pages/lucky-management/components/manage-users";
import { LuckyManagementWinner } from "../pages/lucky-management/components/manage-winner";
import { CustomizeActivityListMember } from "../pages/activity-list/components/customize-activity-list-member";

type MenuConfig = {
  icon?: JSX.Element;
  label: string;
  component: JSX.Element;
  roles?: Roules[];
  path?: string;
  children?: MenuConfig[];
};

const menuConfigs: MenuConfig[] = [
  // {
  //   icon: <DashboardOutlined />,
  //   label: "Dashboard",
  //   path: "dashboard",
  //   // roles: [UserRole.dashboard],
  //   component: (
  //     <>
  //       <Route index element={<MainDashboard />} />
  //     </>
  //   ),
  // },
  {
    icon: <FileTextOutlined />,
    label: "Activity Form",
    path: "activity",
    // roles: [UserRole.dashboard],
    component: (
      <>
        <Route index element={<MainAgenda />} />
      </>
    ),
  },
  {
    icon: <UnorderedListOutlined />,
    label: "Activity List",
    path: "activitylist",
    // roles: [UserRole.dashboard],
    component: (
      <>
        <Route index element={<MainactivityList />} />
        <Route path="importfile" element={<ImportFile />} />
        <Route path="activity-list-member/:agendaId" element={<ActivityListMember />} />   
        <Route path="/activitylist/costumize-activity-list-member" element={<CustomizeActivityListMember />}/>
      </>
    ),
  },
  {
    icon: <AppstoreAddOutlined />,
    label: "Lucky Management",
    path: "lucky-management",
    // roles: [UserRole.dashboard],
    component: (
      <>
        <Route index element={<IndexLuckyManagement />} />
        <Route path=":id/:agendaid" element={<LuckyManagementUser />} />
        <Route path="winner/:id/:agendaid" element={<LuckyManagementWinner />} />
      </>
    ),
  },
  {
    icon: <TrophyOutlined />,
    label: "Lucky Draw",
    path: "lucky-draw",
    // roles: [UserRole.dashboard],
    component: (
      <>
        <Route index element={<IndexLuckyDraw />} />
        <Route path=":id" element={<PlayDraw />} />
      </>
    ),
  },

  // {
  //   icon: <IdcardOutlined />,
  //   label: "checkin activity",
  //   path: "manulcheckin",
  //   // roles: [UserRole.dashboard],
  //   component: (
  //     <>
  //       <Route index element={<MainCheckmanul />} />
  //     </>
  //   ),
  // },
  // {
  //   icon: <IdcardOutlined />,
  //   label: "set seat no.",
  //   path: "setseatno",
  //   // roles: [UserRole.dashboard],
  //   component: (
  //     <>
  //       <Route index element={<MainSeatno />} />
  //     </>
  //   ),
  // },
];

export type MenuItem = MenuConfig & {
  path: string;
  key: string;
  children?: MenuItem[];
};

const menuItemMapper = (x: any): MenuItem => {
  const path = pipe(toLower, replace(" ", "-"))(x.path || x.label);
  return {
    ...x,
    key: path,
    path,
    ...(x.children?.length && {
      children: x.children.map(menuItemMapper),
    }),
  };
};

export const menuItems = menuConfigs.map(menuItemMapper);

const [firstMenu] = menuItems;

export const defaultPath = `${firstMenu.path}${firstMenu.children ? `/${firstMenu.children[0].path}` : ""}`;
